import { Box, Typography } from "@mui/material";

// Settings card in the app's settings-page style (see Voice/WhatsAppVoiceSettings):
// white, #eceff1 border, 12px radius, 600-weight title with a muted description.
export default function SectionCard({ title, description, headerAction = null, footer = null, children, ...rest }) {
  return (
    <Box
      sx={{
        bgcolor: "#ffffff",
        border: "1px solid #eceff1",
        borderRadius: "12px",
        px: { xs: 2, md: 3 },
        py: 2.5,
      }}
      {...rest}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2, mb: 2.5 }}>
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: "1.05rem" }}>{title}</Typography>
          {description && (
            <Typography sx={{ fontSize: "0.82rem", color: "#888", mt: 0.25 }}>{description}</Typography>
          )}
        </Box>
        {headerAction}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>{children}</Box>

      {footer && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3, pt: 2, borderTop: "1px solid #eceff1" }}>
          {footer}
        </Box>
      )}
    </Box>
  );
}

// A labelled group inside a card: its own bordered panel with a shaded header, so
// neighbouring groups read as separate sections.
export function FieldGroup({ title, description, children }) {
  return (
    <Box component="section" aria-label={title} sx={{ border: "1px solid #e3e7ea", borderRadius: "10px", overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#f7f9fa", borderBottom: "1px solid #e3e7ea", px: 2, py: 1.25 }}>
        <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>{title}</Typography>
        {description && <Typography sx={{ fontSize: "0.82rem", color: "#888", mt: 0.25 }}>{description}</Typography>}
      </Box>
      <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>{children}</Box>
    </Box>
  );
}
